import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("immersion_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// When an admin session expires or is rejected, every /admin/* call returns 401.
// Instead of silently showing a blank dashboard, clear the token and send the
// admin back to the login screen. Scoped to admin/staff routes so public pages
// are never affected, and skips the login/me calls to avoid redirect loops.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/me");
    const onAdminRoute = path.startsWith("/admin") || path.startsWith("/staff");
    if (
      status === 401 &&
      !isAuthCall &&
      onAdminRoute &&
      path !== "/admin/login" &&
      localStorage.getItem("immersion_admin_token")
    ) {
      localStorage.removeItem("immersion_admin_token");
      window.location.href = "/admin/login?expired=1";
    }
    return Promise.reject(err);
  }
);

// Approx. conversion for display only (≈ 123 ISK per USD)
export const USD_PER_ISK = 1 / 123;

export const formatUSD = (isk) =>
  `$${Math.round(Number(isk || 0) * USD_PER_ISK).toLocaleString("en-US")}`;

export const formatISK = (n) =>
  `${Number(n || 0).toLocaleString("en-US")} ISK (~${formatUSD(n)})`;

export const formatDate = (iso) => {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "long" });
};

// On-site activities at the Viking Village — no round-trip transfer needed.
// They stay in the Transfer Planner but are pinned, locked and shown in a
// distinct colour (they can't be assigned to a transfer car).
export const NO_TRANSFER_TOUR_IDS = new Set([
  "buggy",
  "helicopter",
  "super_jeep_black_beach",
  "super_jeep_highlands",
  "horseback",
]);
export const isOnSite = (b) =>
  NO_TRANSFER_TOUR_IDS.has(b?.tour_id) || b?.type === "buggy";
export const needsTransfer = (b) => !isOnSite(b);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
